import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturesSection.scss';

const FeaturesSection = () => {
  const features = [
    {
      title: 'Omni Channel Integration',
      description: "Seamlessly switch between communication channels to suit your circumstances and preferred channels. At the office, at home, or on the go, you'll always be able to stay in contact.",
      icon: 'headset.svg'
    },
    {
      title: 'Voice Recognition',
      description: 'Talk to your AI chatbot assistant to communicate complex concepts rapidly. Stay flexible and conveniently get things done from anywhere, however you prefer to communicate.',
      icon: 'mic.svg'
    },
    {
      title: 'Multi Language Support',
      description: 'Working across multiple countries? More comfortable communicating in your native tongue? Our AI chatbots support a wide range of languages and can automatically transition between them.',
      icon: 'globe.svg'
    }
  ];

  return (
    <section className="features section">
      <div className="container">
        <h2 className="features__title">FEATURES</h2>
        <div className="grid grid--3-cols">
          {features.map((feature, index) => (
            <div key={index} className="features__card">
              <div className="features__icon">
                <img
                  src={require(`../assets/images/${feature.icon}`)}
                  alt={feature.title}
                />
              </div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__description">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="features__cta">
          <Link to="/features" className="button button--primary">
            Learn More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 
